export const importingBatchAdjustmentsSelector = ({ provision }) =>
  provision.batchAdjustments.importingBatchAdjustments;
export const uploadingBatchAdjustmentsSelector = ({ provision }) =>
  provision.batchAdjustments.uploadingBatchAdjustments;
export const uploadedBatchAdjustmentsSelector = ({ provision }) =>
  provision.batchAdjustments.uploadedBatchAdjustments;
